export default __webpack_public_path__ + "static/media/home-stadium-bg-sm.08b7548a.png";